import { ModalActionDef, ModalDefine, ModalStatus } from '@/libs/formHelper/modalForm/type'

import { GenealogyApply } from '@/api/genealogy/GenealogyApply'

export type TRejectApply = Pick<GenealogyApply, 'id'|'because'>

export default function getModalDefine (view: any): ModalDefine<TRejectApply> {
  const items = [{
    title: '驳回原因',
    required: true,
    type: {
      module: 'textarea'
    },
    key: 'because'
  }]

  const actions: ModalActionDef<TRejectApply>[] = [{
    key: 'create',
    title: '提交',
    type: 'submit',
    button: 'success',
    actionClose: true,
    modalStatus: ModalStatus.ADD,
    onClick: (item: TRejectApply) => {
      return view.rejectHandle(item)
    }
  }]

  return {
    items,
    actions
  }
}
